import createAxiosInstance from './axiosConfig';
import { PropostaDTO } from '../shared/dto/propostaDTO';
import { FiltroPropostaDTO } from '../shared/dto/filtroPropostaDTO';
import { Cliente } from '../shared/model/Cliente';
import { CalculoResultadoSimulacaoDTO } from '../shared/dto/calculoResultadoSimulacaoDTO';
import { ResultadoSimulacaoPropostaDTO } from '../shared/dto/resultadoSimulacaoPropostaDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/propostaController');

export default class PropostaService {
  axios: any; 

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasPropostas(currentPage: number, max: number, dto: FiltroPropostaDTO) {
    return await this.axios.post(`/listarTodasPropostas?page=${currentPage}&max=${max}`, dto);
  };

  async listarPropostasParaLote(currentPage: number, max: number, dto: FiltroPropostaDTO) {
    return await this.axios.post(`/listarPropostasParaLote?page=${currentPage}&max=${max}`, dto);
  };

  async listarPropostaEspelhoJasper(idProposta: number) {
    return await this.axios.get(`/listarPropostaEspelhoJasper?idProposta=${idProposta}`, {
      responseType: 'blob', 
    });
  };

  async listarAtividadesDisponiveis(esteira: number) {
    return await this.axios.post(`/listarAtividadesDisponiveis?esteira=${esteira}`);
  };

  async aprovarReprovarEmLote(isAprovar: boolean, motivo: string | null, dto: PropostaDTO[]) {
    
    const motivoParam = motivo ? `&idMotivo=${motivo}` : '';
    return await this.axios.post(`/aprovarReprovarEmLote?isAprovar=${isAprovar}${motivoParam}`, dto);
  };

  async listarPropostaEFluxoAnteriores(idProposta: string) {
    return await this.axios.get(`/listarPropostaEFluxoAnteriores?idProposta=${idProposta}`);
  };

  async obterMargemOnline(codigoExterno: string, empregador: string, promotora: string, loja: string, dto: Cliente, tpProduto: string) {
    return await this.axios.post(`/obterMargemOnline?convenio=${codigoExterno!}&empregador=${empregador!}&promotora=${promotora!}&loja=${loja!}&tpProduto=${tpProduto!}`, dto);
  };

  async simulacaoRMCTotal(dto: CalculoResultadoSimulacaoDTO) {
    return await this.axios.post(`/simulacaoRMCTotal`, dto);
  };

  async resultadoSimulacaoParcela(dto: ResultadoSimulacaoPropostaDTO) {
    return await this.axios.post(`/resultadoSimulacaoParcela`, dto);
  };

  async inclusaoProposta(dto: PropostaDTO) {
    return await this.axios.post(`/inclusaoProposta`, dto);
  };

  async listarPropostaParaReprovacao(idProposta: string) {
    return await this.axios.get(`/listarPropostaParaReprovacao?idProposta=${idProposta}`);
  };

  async liberarAnalise(idProposta: number): Promise<any> {
    return await this.axios.post(`/liberarAnalise?idProposta=${idProposta}`);
  }

  async bloquearProposta(idProposta: number, idUsuario: number): Promise<void> {
    try {
     
      await this.axios.post(`/bloquear`, { idProposta, idUsuario });
     

    } catch (error: any) {
      console.error('Erro na requisição de bloqueio:', error);
      
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message); 
      } else if (error.message) {
        throw new Error(error.message); 
      } else {
        throw new Error('Erro desconhecido ao bloquear a proposta.');
      }
    }
  }

  async atualizarProposta(dto: PropostaDTO) {
    return await this.axios.post(`/atualizarProposta`, dto);
  };

  async atualizarDadosBancarios(dto: PropostaDTO) {
    return await this.axios.post(`/atualizarDadosBancarios`, dto);
  };

  async listarPropostasAnterioresPorCpf(cpf: string, idPropostaAtual: number) {
    return await this.axios.get(`/listarPropostasAnterioresPorCpf?cpf=${cpf}&idPropostaAtual=${idPropostaAtual}`);
  };

  async listarIntegracoesExternasPorProposta(idProposta: number, page: number, size: number) {
    return await this.axios.get(`/listarIntegracoesExternasPorProposta?idProposta=${idProposta}&page=${page}&size=${size}`);
  };
  

  async verificaContratosCompraDivida(idProposta: number, cpf: string, matricula: string) {
    return await this.axios.get(`/verificaContratosCompraDivida?idProposta=${idProposta}&cpf=${cpf}&matricula=${matricula}`);
  }
}